import { useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import type { Column } from 'react-table';
import { useTable, useFlexLayout, useSortBy, usePagination } from 'react-table';
import type { ProjectItem } from '@trinity/chat/api/interfaces/projects';
import { useProjectsTableColumns } from '@/components/GroupProject/hooks/useProjectsTableColumns';
import { Card, CardContent, GroupCardHeader } from '@trinity/chat-components/components/presentation/Main/index.js';
import * as Table from '@/components/Table';
import * as consts from '@/consts';
// import { useIsInternalUser } from '@/containers/Store';
// import { getLocationFor } from '@trinity/chat-components';
// import { GuidedTourPopper, TourStep } from '@/components/GuidedTour/GuidedTourPopper';
// import { useSequentialTour } from '@/components/GuidedTour/useSequentialTour';
import styles from './style/ActiveProjectsPanel.module.css';

const MaxProjects = 5;

function EmptyState() {
  return (
    <div className={styles.empty}>
      <div className={styles.title}>No active projects</div>
      <div className={styles.text}>Create a project to get started</div>
    </div>
  );
}

type Props = {
  data: ProjectItem[];
  empty: boolean;
  loading: boolean;
};

export const ActiveProjectsPanel = (props: Props) => {
  const projectsHeaderRef = useRef<HTMLDivElement>(null);
  // const { isStepActive, goToNextStep, goToPreviousStep, dismissTour, currentStepIndex, totalSteps, isFirstStep } = useSequentialTour();

  const columns = useProjectsTableColumns() as Column<ProjectItem>[];
  // const isInternalUser = useIsInternalUser();

  const filteredData = useMemo(() => props.data.slice(0, 5), [props.data]);

  const params = {
    columns,
    data: filteredData,
    disableSortBy: true,
    initialState: {
      pageIndex: 0,
      pageSize: MaxProjects,
      sortBy: [{
        id: 'createdOn',
        desc: true,
      }],
    },
  };

  const {
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable<ProjectItem>(
    params,
    useFlexLayout,
    useSortBy,
    usePagination,
  );

  const showMore = useMemo(() => props.data.length > MaxProjects, [props.data.length]);

  return (
    <Card>
      <GroupCardHeader className={styles.header}>
        <div ref={projectsHeaderRef}>Projects</div>
        {/* {isInternalUser && (
          <GroupTableHeaderButton
            title="Create New"
            to={consts.path.Projects.Create} />
        )} */}
      </GroupCardHeader>
      <CardContent fluid>
        <Table.Root
          EmptyComponent={EmptyState}
          empty={props.empty}
          loading={props.loading}>
          <Table.Header headerGroups={headerGroups} />
          <Table.Body
            {...getTableBodyProps()}
            classes={{
              tbody: styles.body,
              td: styles.td,
            }}
            prepareRow={prepareRow}
            rows={rows} />
          {showMore &&
            <Table.Layout.Footer>
              <StyledFooter>
                <Link to={consts.path.Projects.Root}>View More...</Link>
              </StyledFooter>
            </Table.Layout.Footer>}
        </Table.Root>
      </CardContent>
      {/* {isStepActive(TourStep.TRACK_PROJECTS) && projectsHeaderRef.current && (
        <GuidedTourPopper
          containerRef={projectsHeaderRef.current}
          step={TourStep.TRACK_PROJECTS}
          isOpen={true}
          onNext={goToNextStep}
          onBack={!isFirstStep ? goToPreviousStep : undefined}
          onGotIt={goToNextStep}
          onDismiss={dismissTour}
          placement="right"
          currentStep={currentStepIndex + 1}
          totalSteps={totalSteps}
          showDots={true} />
      )} */}
    </Card>
  );
};

export default ActiveProjectsPanel;

const StyledFooter = styled.div(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.primary.main,
  fontFamily: 'var(--font-semibold)',
  padding: 15,
}));
